import axios from 'axios'
import { socket } from '@/main'
import { Device } from "twilio-client"

export default {
  namespaced: true,
  state: {
    token: null,
    user: null,
    isAuth: false,
    online: false,
    loadingAuth: false,
    signInError: false,
    redirectId: null,
    text: null
  },

  getters: {
    user: state => state.user,
    isAuth: state => state.isAuth,
    isGuide: state => {
      if (state.user != null) return state.user.role_id == 3;
      return false;
    },
    online: state => state.online,
    loadingAuth: state => state.loadingAuth,
    fullname: state => `${state.user.fname} ${state.user.lname}`,
    role: state => {
      switch (state.user.role_id) {
        case 1: return 'Admin';
        case 2: return 'Agent';
        case 3: return 'Guide';
      }
    },
    redirectId: state => state.redirectId
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
    },

    SET_USER(state, data) {
      state.user = data;
    },

    SET_AUTH(state, isAuth) {
      state.isAuth = isAuth;
    },

    SET_ONLINE_STATUS(state, status) {
      state.online = status
    },

    SET_LOADING_AUTH(state, loading) {
      state.loadingAuth = loading;
    },
    SET_TEXT_MESSAGE(state, message) {
      state.user.text_message = message;
    },
    SET_VOICE_MAIL(state, voice_mail) {
      state.user.voice_mail = voice_mail;
    },
    SET_SIGNIN_ERROR(state, error) {
      state.signInError = error;
    },
    SET_UNCOMPLETED_LEAD(state, uncompleted_lead) {
      state.user.uncompleted_lead = uncompleted_lead;
    },
    "SOCKET_SET_UNCOMPLETED_LEAD"(state, uncompleted_lead) {
      state.user.uncompleted_lead = uncompleted_lead;
    },
    "SOCKET_ADD_LEAD_ID"(state, lead_id) {
      state.redirectId = lead_id;
    },
    "SOCKET_FOLLOWUP_NOTIFICATION"(state, text) {
      state.text = text;
    }
  },
  actions: {
    signIn({ commit }, credentials) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING_AUTH", true);

        axios.post("auth/signin", credentials)
          .then(res => {
            commit("SET_TOKEN", res.data.token);
            commit("SET_USER", res.data.user);
            commit("SET_ONLINE_STATUS", res.data.user.online);
            socket.emit("connected", res.data.user);
            commit("SET_LOADING_AUTH", false);
            commit("SET_AUTH", true);

            return resolve(res.data);
          })
          .catch(error => {
            commit("SET_LOADING_AUTH", false);
            commit("SET_AUTH", false);

            return reject(error);
          })
      });
    },

    verifyUser({ commit }, token) {
      if (token) {
        return new Promise((resolve, reject) => {
          commit("SET_LOADING_AUTH", true);

          axios.post("auth/verify", { token })
            .then((res) => {
              commit("SET_TOKEN", token);
              commit("SET_USER", res.data.user);
              socket.emit("connected", res.data.user);
              commit("SET_ONLINE_STATUS", res.data.user.online);
              commit("SET_AUTH", true);
              commit("SET_LOADING_AUTH", false);

              return resolve();
            })
            .catch(error => {
              commit("SET_LOADING_AUTH", false);
              commit("SET_AUTH", false);
              console.log(error);
              return reject(error);
            })
        })
      }
      return;
    },

    twilioTokenHandler({ commit, state }, user_id) {
      if (state.online) {
        axios.post("/call/token/" + user_id)
          .then((res) => {
            Device.setup(res.data.token, { debug: true });
          })
          .catch((err) => {
            commit("SET_ONLINE_STATUS", false);
            this.$socket.emit("set_online_status", {
              id: user_id,
              status: false,
            });
            console.log(err);
          });
      } else {
        Device.destroy();
      }
    },

    "SOCKET_SWITCH_INBOUND_STATUS"({ commit }, status) {
      commit("SET_INBOUND_STATUS", status);
    },

    signOut({ commit }) {
      commit("SET_TOKEN", null);
      commit("SET_USER", null);
      commit("SET_AUTH", false);
    }
  },

};
